import { SCALING_RULES, UNIT_TYPE_MAP, UnitType } from './unitConfig'

export interface ScaledValue {
  displayValue: number
  displayUnit: string
}

export interface FormattedMetricValue {
  formattedValue: string
  displayUnit: string
}

export function getUnitType(unit: string): UnitType | null {
  return UNIT_TYPE_MAP[unit] || null
}

export function scaleValueWithUnit(value: number, unit: string): ScaledValue {
  const unitType = getUnitType(unit)

  if (!unitType || !SCALING_RULES[unitType]) {
    return { displayValue: value, displayUnit: unit }
  }

  const rule = SCALING_RULES[unitType]
  const threshold = rule.thresholds.find((t) => value >= t.min && value < t.max)

  if (!threshold) {
    return { displayValue: value, displayUnit: unit }
  }

  const displayValue = value / threshold.divisor

  return {
    displayValue,
    displayUnit: threshold.unit,
  }
}

export function formatMetricValue(value: number, unit: string): FormattedMetricValue {
  const scaled = scaleValueWithUnit(value, unit)
  const unitType = getUnitType(unit)
  const defaultPrecision = unitType ? SCALING_RULES[unitType].precision : 2

  return {
    formattedValue:
      Number(scaled?.displayValue)?.toFixed(defaultPrecision).replace(/\.0+$/, '') || '0', //Strip trailing zeros after decimal
    displayUnit: scaled?.displayUnit || '',
  }
}
